import type { AliasResolution, FeatureFlagsOverrides, Filter, QueryObjectRequest, TFileFormat, TQueryOrigin } from '@fabric-ui/components';
import type { DwQueryRequest } from './QueryObject.types';

const construct = <T extends Partial<QueryObjectRequest>>(q: T) => {
  const setQuery = (query: DwQueryRequest) => construct({ ...q, query });

  const setOrigin = (origin: TQueryOrigin) => construct({ ...q, origin });

  const setTotalRowCount = (totalRowCount: boolean) => construct({ ...q, totals: { ...q.totals, totalRowCount } });

  const setTotalRow = (totalRow: boolean) => construct({ ...q, totals: { ...q.totals, totalRow } });

  const setIsCacheEnabled = (isCacheEnabled: boolean) => construct({ ...q, isCacheEnabled });

  const setFileFormat = (fileFormat: TFileFormat) => construct({ ...q, fileFormat });

  const setContextFilter = (contextFilter: Filter) => construct({ ...q, contextFilter });

  const setMaxFileSize = (maxFileSize: number) => construct({ ...q, maxFileSize });

  const setMultipleFiles = (multipleFiles: boolean) => construct({ ...q, multipleFiles });

  const setQueryId = (queryId: string) => construct({ ...q, queryId });

  const setAliasResolution = (...aliasResolution: AliasResolution[]) => construct({ ...q, aliasResolution });

  const setTags = (...tags: string[]) => construct({ ...q, tags });

  const setFeatureFlagsOverrides = (featureFlagsOverrides: FeatureFlagsOverrides) => construct({ ...q, featureFlagsOverrides });

  const build = () => structuredClone(q) as QueryObjectRequest;

  return {
    setQuery,
    setOrigin,
    setTotalRowCount,
    setTotalRow,
    setIsCacheEnabled,
    setFileFormat,
    setContextFilter,
    setMaxFileSize,
    setMultipleFiles,
    setQueryId,
    setAliasResolution,
    setTags,
    setFeatureFlagsOverrides,
    build,
  };
};

const create = () => construct({});
const from = (baseObject: Partial<QueryObjectRequest>) => construct(baseObject);

export const queryObjectRequestBuilder = {
  create,
  from,
};
